import React from 'react';
import PropTypes from 'prop-types';
import CustomLink from '../CustomLink';
import { TERMS_OF_USE_LINK, PRIVACY_POLICY_LINK } from '../../shared/links';
import styles from './AgreementTextV6.css';

function AgreementTextV6({ legalLinks = { privacyPolicy: PRIVACY_POLICY_LINK, termsOfUse: TERMS_OF_USE_LINK } }) {
    return (
        <p className={styles.agreementText}>
            {'By proceeding, you agree with '}
            <CustomLink
                to={legalLinks.termsOfUse}
                target='_blank'
            >
                Terms&nbsp;of&nbsp;Service
            </CustomLink>
            {' and '}
            <CustomLink
                to={legalLinks.privacyPolicy}
                target='_blank'
            >
                Privacy&nbsp;Policy
            </CustomLink>
        </p>
    );
}

AgreementTextV6.propTypes = {
    legalLinks: PropTypes.object
};

export {
    AgreementTextV6
};
